import { ILicitacaoPagedResponse } from "models/response/licitacao-paged-response";

export interface LicitacaoDetailsState {
  licitacaoDetails: ILicitacaoPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setLicitacaoDetails: 'setLicitacaoDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface LicitacaoDetailsAction {
  type: ActionType;
  payload: any;
}

export const LicitacaoDetailsReducer = (
  state: LicitacaoDetailsState,
  action: LicitacaoDetailsAction
): LicitacaoDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setLicitacaoDetails:
      return { ...state, licitacaoDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
